module.exports = __webpack_public_path__ + "img/contrology_Website_nav_logo@2x.63442dd3.png";